export default __webpack_public_path__ + "static/media/header-bg.c4647202.png";